export default [
  'box-shadow: inset 0 7px 9px -7px rgba(0,0,0.7);',
  'box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);',
  'box-shadow: 0 3px 6px rgba(0,0,0,0.10), 0 6px 6px rgba(0,0,0,0.10);',
  'box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);',
  'box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);'
];
